import { cbi_waste_quantity_unit_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiWasteQuantityUnitEnum = (enumValue: cbi_waste_quantity_unit_enum) => {
  switch (enumValue) {
    case cbi_waste_quantity_unit_enum.KG:
      return <Trans i18nKey="Enum_CbiWasteQuantityUnitEnum-KG" />;
    case cbi_waste_quantity_unit_enum.L:
      return <Trans i18nKey="Enum_CbiWasteQuantityUnitEnum-L" />;
    case cbi_waste_quantity_unit_enum.M3:
      return <Trans i18nKey="Enum_CbiWasteQuantityUnitEnum-M3" />;
    case cbi_waste_quantity_unit_enum.PIECE:
      return <Trans i18nKey="Enum_CbiWasteQuantityUnitEnum-PIECE" />;
    case cbi_waste_quantity_unit_enum.T:
      return <Trans i18nKey="Enum_CbiWasteQuantityUnitEnum-T" />;
  }
};

export const translateCbiWasteQuantityUnitEnum_dynamic = (enumValue: cbi_waste_quantity_unit_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_waste_quantity_unit_enum.KG:
      return t('Enum_CbiWasteQuantityUnitEnum-KG');
    case cbi_waste_quantity_unit_enum.L:
      return t('Enum_CbiWasteQuantityUnitEnum-L');
    case cbi_waste_quantity_unit_enum.M3:
      return t('Enum_CbiWasteQuantityUnitEnum-M3');
    case cbi_waste_quantity_unit_enum.PIECE:
      return t('Enum_CbiWasteQuantityUnitEnum-PIECE');
    case cbi_waste_quantity_unit_enum.T:
      return t('Enum_CbiWasteQuantityUnitEnum-T');
  }
};
